import {
  useQuery,
  useMutation,

} from "react-query";
// import { customApi } from "../../../../CustomHoock/CustomApi";
// import { customApi } from "../../../../CustomHoock/CustomApi";
import { useDispatch, useSelector } from "react-redux";
import { useQueryClient } from "react-query";
// import customApi
import {
  GetOrderView,
  GetAllOrganizationUnit,
  PostOrganizationUnit,
  GetMessageOrganizationSend,
  EditMessageOrganizationSend,
  deleteMessageOrganization,
  GetOrderData,
  compaireOrder,
  compaireOrderDataInfo,
  getMessageSignalr,
  editOrderDescription,
  getdesigningDepartment,
  changeOrderStatus,
  changeOrderState,
  addOrderDamageReport,
  getGroupCausesDamage,
  getOrderDamage,
  deleteOrderDamgeImage,
  getRelatedOrders,
  getAllDamageItems,
  addOrUpdateDamageItem,
  deleteItemDamage,
  editOrderDamageReport
  // getRelatedOrders
} from "../Api";

// import { useGetRelatedOrders } from "../Hooks";

import {
  getOrderTotalR, getOrderViewDataR,
} from "../Store/GeneralSlice";
import { customApi } from "../../CustomHoock/CustomApi";

/**==============================================
 *                react Query
 *
 *
 *
 *
 *=============================================**/

/**=======================
 *     GetOrders for Data Grid
 *
 *
 *========================**/
const useGetOrderData = (getOrderBody) => {
  const dispatch = useDispatch();
  return useQuery(["getAllApi", getOrderBody], GetOrderData, {
    enabled: !!getOrderBody,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      dispatch(getOrderTotalR(data.data.totalRecord));
      return data;
    },
    onError: (error) => {
    },
  });
};



//orderView
const useGetOrderView = () => {
  const dispatch=useDispatch()
  return useMutation(GetOrderView, {
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      dispatch(getOrderViewDataR(data));
    },
  
  });
};



//GetAllOrganizationUnit
const useGetAllOrganizationUnit = () => {
  return useQuery(["getALLOrganizationUnit"], GetAllOrganizationUnit, {
    refetchOnWindowFocus: false,
    staleTime: 9 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    onSuccess: (data) => {
      return data;
    },
  
  });
};

//post organization
const usePostOrganizationUnit = () => {
  return useMutation(PostOrganizationUnit, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      return res
    },
  
  });
};





const useGetMessageOrganizationSend = (body) => {
  return useQuery(
    ["getOrganizationMessageSend"],
    () => GetMessageOrganizationSend(body),
    {
      refetchOnWindowFocus: false,
     enabled:!!body,
      
    }
  );
};

/**=======================
 *    Edite  organization message
 *
 *
 *========================**/
const useEditMessageOrganizationSend = (
  EditSend,
  messageData,
  messageRefetch
) => {
  return useQuery(
    ["EditeOrganizationMessage", messageData],
    EditMessageOrganizationSend,
    {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      enabled: !!EditSend,
      onSuccess: (data) => {
        messageRefetch();
      },

    }
  );
};

/**=======================
 *         Delet Organization Message
 *
 *
 *========================**/
const useDeleteMessageOrganization = (messageRefetch) => {
  return useMutation(deleteMessageOrganization, {
    onSuccess: (res) => {
      messageRefetch();
    },

  });
};


/**=======================
 *     compaireOrder
 *  
 *  
 *========================**/

const useCompaireOrder =(orderId)=>{
  return useQuery(
    ["useCompaireOrder"],
    ()=>compaireOrder(orderId),
    {
      refetchOnWindowFocus: false,

    }
  );
}
/**=======================
 *     get compaireOrderDataInfo
 *  
 *  
 *========================**/
const useCompaireOrderDataInfo = () => {
  return useMutation(compaireOrderDataInfo, {

  });
};

/**==============================================
 *                Order search By order Number
 *  
 *  
 *  
 *  
 *=============================================**/
const useGetOrderByorderNumber=()=>{
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/OrderStepLog/GetSingleOrderByOrderNumber",
        requestBody: body,
        reactQuery: "mutate",
        }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        return data;
      },
    
     
    }
  );
}


/**=======================
 *     get message signalr hook
 *  
 *  
 *========================**/

const useGetmessageSignalr =(orderId)=>{

  return useQuery(
    ["getMessageSignar",orderId],
    ()=>getMessageSignalr(orderId),
    {
      refetchOnWindowFocus: false,
   
    }
  );

}

const useEditOrderDescription=()=>{
  return useMutation(editOrderDescription,{
    onSuccess:(data)=>{
    }
  })
}

const useGetProcessDropDown=(changeProcessState)=>{
  return useQuery(['GetProcessDropDown'],getdesigningDepartment,{
    refetchOnWindowFocus:false,
    cacheTime:Infinity,
    enabled:!!changeProcessState,
    onSuccess:(data)=>{
    //  console.log(data)
    },
    onError:(err)=>{
    // console.log(err)
    },

    select:(data)=>{
    let rawData=data?.data?.data;
    let trensFormed=rawData.map((item)=>{
      let{id,stateName,isActive}=item;
      return{key:stateName,value:id,isActive}
    })

    

      return trensFormed

    }
  })


  
}




const useGetModuleAvailableProcessState = (controler) => {
  let totalRecord;
  return useQuery(
    ["useGetModuleAvailableProcessState"],
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/${controler}/GetAvailableStates`,
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,
      enabled:!!controler,
      onSuccess: (data) => {
        // return data;
      },
     
      select: (data) => {
        // console.log(data)
        totalRecord = data?.data.totalRecord; //for pagnation
        let transformed=data?.data?.data.map((item)=>{
          let {stateName:key,id:value,isActive}=item
          return {key,value,isActive}
        })
        // console.log(transformed)
        let res = data?.data.data;
        return transformed;
      },
    }
  );
};



const useChangeOrderStatus=(afterChangeStatus)=>{

    return useMutation(changeOrderStatus,{
      onSuccess:(data)=>{
      afterChangeStatus();
      },
     

    }

    )
  
}

const useGChangeOrderState=(afterChangeState)=>{
    return useMutation(changeOrderState,{
      onSuccess:(data)=>{
    //  console.log(data)
     afterChangeState();
    //  queryClient.invalidateQueries()
      },
     

    }

    )
  
}
// addDamageReportSuccess,addDamageReportfailed
const useAddOrderDamageReport = (addDamageReportSuccess,addDamageReportfailed) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(addOrderDamageReport,{
      onSuccess: (data) => {
        queryClient.invalidateQueries(['getAllOrders'],{exact:true});
          addDamageReportSuccess();
      }
      , onError: (err) => {
          addDamageReportfailed()
      }
  })
}

// http://192.168.3.17:91/api/v1/OrderDamage/EditOrderDamage
const useEditOrderDamageReport = (editDamageReportSuccess,ediDamageReportfailed) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(editOrderDamageReport,{
      onSuccess: (data) => {
        queryClient.invalidateQueries(['getAllOrders'],{exact:true});
          editDamageReportSuccess();
      }
      , onError: (err) => {
          ediDamageReportfailed()
      }
  })
}



const useGetGroupCausesDamage=()=>{

  return useQuery(['GetGroupCausesDamage'],getGroupCausesDamage,{
    enabled:true,
    refetchOnWindowFocus:false,
    onSuccess:(data)=>{
    }
    ,
   
  })
}
const useGetOrderDamage=(orderId)=>{

  return useQuery(['getOrderDamage',orderId],getOrderDamage,{
    enabled:!!orderId,
    refetchOnWindowFocus:false,
    
   
    select:(data)=>{
   let rawData=data?.data?.data;
   return rawData
    }
   
  })
}


// const useDeleteOrderDamgeImage=()=>{
//   return useMutation
// }


const useDeleteOrderDamgeImage = (deleteSuccess,deleteFailed) => {

  const dispatch=useDispatch();
  return useMutation(
    {
    mutationFn:(data)=>deleteOrderDamgeImage(data),
    onSuccess:(data)=>{
    queryClient.invalidateQueries('getAllCustomers')
    deleteSuccess()
    }



    ,onError:(data)=>{


    
      deleteFailed()
    }
  })
};
// orderNumber: '14041209', orderName: 'تست 2-02-04', id: '34377332-aa29-f011-947a-005056897504'

const useGetRelatedOrders=(body)=>{

  return useQuery(['getRelatedOrders',body],getRelatedOrders,{
    enabled:!!body,
    refetchOnWindowFocus:false,
    select:(data)=>{
      let rawData=data?.data?.data;
      let transformedData = rawData.map(({ id, orderName, orderNumber }) => ({
        key: `${orderName} \\ ${orderNumber}`,
        value: id
      }));
      return transformedData
    }
   
  })
}

// getAllDamageItems

const useGetAllDamageItems=(body)=>{
    return useQuery(['getAllDamageItems',body],getAllDamageItems,{
    enabled:!!body,
    refetchOnWindowFocus:false,
    select:(data)=>{
      let rawData=data?.data?.data;
      return rawData
    }
   
  })
}
// addOrUpdateDamageItem

const useAddOrUpdateDamageItemOrderDamage = (addDamageReportSuccess) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(addOrUpdateDamageItem,{
      onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['getAllDamageItems'], exact: false });
          addDamageReportSuccess();
      }
      , onError: (err) => {
          // addDamageReportfailed()
      }
  })
}

// deleteItemDamage


const useDeleteItemDamage = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation(deleteItemDamage,{
      onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['getAllDamageItems'], exact: false });
          // addDamageReportSuccess();
      }
      , onError: (err) => {
          // addDamageReportfailed()
      }
  })
}






/**==============================================
 *                Export
 *
 *
 *
 *
 *=============================================**/
export {
  useGetOrderData,
  useGetOrderView,
  useGetAllOrganizationUnit,
  usePostOrganizationUnit,
  useGetMessageOrganizationSend,
  useEditMessageOrganizationSend,
  useDeleteMessageOrganization,
  useCompaireOrder,
  useGetOrderByorderNumber,
  useCompaireOrderDataInfo,
  useGetmessageSignalr,
  useEditOrderDescription,
  useGetProcessDropDown,
  useGetModuleAvailableProcessState,
  useChangeOrderStatus,
  useGChangeOrderState,
  useAddOrderDamageReport,
  useGetGroupCausesDamage,
  useGetOrderDamage,
  useDeleteOrderDamgeImage,
  useGetRelatedOrders,
  useGetAllDamageItems,
  useAddOrUpdateDamageItemOrderDamage,
  useDeleteItemDamage,
  useEditOrderDamageReport
  
};
